import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import MessageForm from '../containers/MessageFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class MessageEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `MessageEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('message_route_edit')} />
          <MessageForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default MessageEditScreen;

Logger.log('silly', `MessageEditScreen loaded.`);
